import { userNotificationsQuerySchema } from '@shared/dto/users.dto'
import { userSchema } from '@shared/schemas/users.schemas'
import { z } from 'zod'

export enum UserStatus {
  UNREGISTERED = 'unregistered',
  UNCONFIRMED = 'unconfirmed',
  CONFIRMED = 'confirmed'
}

export enum Language {
  ES = 'es'
}

export type User = z.infer<typeof userSchema>

export type UserNotificationQuery = z.infer<typeof userNotificationsQuerySchema>

export interface DecodedToken {
  aud: string
  auth_time: number
  'cognito:username': string
  event_id: string
  email: string
  email_verified: boolean
  exp: number
  iat: number
  iss: string
  jti: string
  origin_jti: string
  sub: string
  token_use: string
  userId: string
  lastLoginAt?: string
}
